import React, { useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import logo from './ripllogo.png';

const Sidebar = () => {
    const [showDropdown, setShowDropdown] = useState('');
    const location = useLocation();

    const handleItemClick = (menuItem) => {
        if (showDropdown === menuItem) {
            setShowDropdown('');
        } else {
            setShowDropdown(menuItem);
        }
    };

    const isActive = (path) => {
        return location.pathname === path;
    };

    const isParentActive = (dropdownItems) => {
        return dropdownItems.some(item => isActive(navigationPaths[item]));
    };

    const menuItems = [
        { name: 'Dashboard', dropdownItems: [], path: '/dashboard', icon: 'M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6' },
        { name: 'Client', dropdownItems: ['Add Client', 'Manage Client'], icon: 'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z' },
        { name: 'Projects', dropdownItems: ['Add Project', 'Manage Projects'], icon: 'M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10' },
        { name: 'Cluster', dropdownItems: ['Add Cluster', 'Manage Clusters'], icon: 'M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4' },
        { name: 'Cities', dropdownItems: ['Add City', 'Manage Cities'], icon: 'M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z' },
        { name: 'Sites', dropdownItems: ['Add Site', 'Manage Sites'], icon: 'M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0zM15 11a3 3 0 11-6 0 3 3 0 016 0z' },
        { name: 'PSU Devices', dropdownItems: ['Add PSU Device', 'Manage PSU Device', 'Add PSU Access', 'Revoke PSU Access'], icon: 'M13 10V3L4 14h7v7l9-11h-7z' },
        { name: 'Users', dropdownItems: ['Add User', 'Manage Users'], icon: 'M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z' },
        { name: 'Reports', dropdownItems: ['Logs Report', 'Fault Reports', 'AC Fail Report', 'Site Graph Report', 'Site Logs Export'], icon: 'M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z' },
        { name: 'Logout', dropdownItems: [], path: '/', icon: 'M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1' }
    ];

    const navigationPaths = {
        'Add Client': '/client/addclient',
        'Manage Client': '/client/manageclient',
        'Add Project': '/project/addproject',
        'Manage Projects': '/project/manageproject',
        'Add Cluster': '/cluster/addcluster',
        'Manage Clusters': '/cluster/managecluster',
        'Add City': '/city/addcity',
        'Manage Cities': '/city/managecity',
        'Add Site': '/site/addsite',
        'Manage Sites': '/site/managesite',
        'Add PSU Device': '/psu/addpsu',
        'Manage PSU Device': '/psu/managepsu',
        'Add PSU Access': '/psu/addpsuaccess',
        'Revoke PSU Access': '/psu/revokepsu',
        'Add User': '/user/adduser',
        'Manage Users': '/user/manageuser',
        'Logs Report': '/report/logreport',
        'Fault Reports': '/report/faultreport',
        'AC Fail Report': '/report/acfailreport',
        'Site Graph Report': '/report/sitegraphreport',
        'Site Logs Export': '/report/sitelogsexport',
        'Logout': '/'
    };

    return (
        <div className='fixed top-0 left-0 h-screen bg-white border-r border-gray-200 shadow-lg flex flex-col'>
            <div className='flex-shrink-0 p-4 border-b border-gray-200'>
                <img
                    width={180}
                    className='mx-auto'
                    src={logo}
                    alt="Logo"
                />
            </div>
            <div className='flex-1 py-4'>
                {menuItems.map((item, index) => {
                    const isItemActive = item.path ? isActive(item.path) : isParentActive(item.dropdownItems);
                    const shouldShowDropdown = showDropdown === item.name || isItemActive;

                    return (
                        <div
                            key={index}
                            className={`${shouldShowDropdown ? 'bg-blue-50' : ''} transition-colors duration-200`}
                        >
                            <div 
                                className='flex items-center justify-between px-6 py-3 cursor-pointer hover:bg-gray-50'
                                onClick={() => handleItemClick(item.name)}
                            >
                                <NavLink
                                    to={item.path || '#'}
                                    className={`flex items-center gap-3 text-sm font-medium ${
                                        isItemActive ? 'text-blue-600' : 'text-gray-700 hover:text-blue-600'
                                    }`}
                                >
                                    <svg 
                                        className="w-5 h-5" 
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24"
                                    >
                                        <path 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round" 
                                            strokeWidth="2" 
                                            d={item.icon}
                                        />
                                    </svg>
                                    {item.name}
                                </NavLink>
                                {item.dropdownItems.length > 0 && (
                                    <svg 
                                        className={`w-4 h-4 text-gray-500 transition-transform duration-200 ${
                                            shouldShowDropdown ? 'transform rotate-180' : ''
                                        }`}
                                        fill="none" 
                                        stroke="currentColor" 
                                        viewBox="0 0 24 24"
                                    >
                                        <path 
                                            strokeLinecap="round" 
                                            strokeLinejoin="round" 
                                            strokeWidth="2" 
                                            d="M19 9l-7 7-7-7"
                                        />
                                    </svg>
                                )}
                            </div>
                            {shouldShowDropdown && item.dropdownItems.length > 0 && (
                                <div className='pl-14 pr-6 py-2 space-y-1'>
                                    {item.dropdownItems.map((dropdownItem, index) => (
                                        <NavLink
                                            key={index}
                                            to={navigationPaths[dropdownItem]}
                                            className={`block px-3 py-2 text-sm font-medium rounded-md transition-colors duration-200 ${
                                                isActive(navigationPaths[dropdownItem])
                                                    ? 'bg-blue-100 text-blue-600' 
                                                    : 'text-gray-600 hover:bg-gray-50 hover:text-blue-600'
                                            }`}
                                        >
                                            {dropdownItem}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Sidebar;
